import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './calculator-asset-finance-tab.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorAssetFinanceTab = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorAssetFinanceTab, _super);
    function CalculatorAssetFinanceTab(element) {
        return _super.call(this, element) || this;
    }
    CalculatorAssetFinanceTab.prototype.init = function () {
        TooltipsService.initTooltips();
        this.form = this.element.querySelector('form');
        this.monthlyRepaymentElement = this.element.querySelector('.js-asset-tab-monthly-repayment');
        this.repaymentsElement = this.element.querySelector('.js-asset-tab-repayments');
        this.totalRepaymentsElement = this.element.querySelector('.js-asset-tab-total-repayments');
        this.financeChargesElement = this.element.querySelector('.js-asset-tab-finance-charges');
        this.avgSavingElement = this.element.querySelector('.js-asset-tab-avg-saving');
        this.newInterestRateElement = this.element.querySelector('.js-asset-tab-new-interest-rate');
        this.newTotalRepaymentsElement = this.element.querySelector('.js-asset-tab-new-total-repayments');
        this.interestReductionElement = this.element.querySelector('.js-asset-tab-interest-reduction');
        this.bannerTitleElement = this.element.querySelector('.js-asset-tab-banner-title');
        this.repaymentsLabelElement = this.element.querySelector('.js-asset-tab-repayments-label');
        this.clearInputsButton = this.element.querySelector('.js-calculator-clear-inputs');
        this.calculateButton = this.element.querySelector('.js-calculator-calculate');
        this.resultsElement = this.element.querySelector('.calculator-asset-finance-tab__results');
        this.interestRateInput = this.element.querySelector('[name="interest_rate"]');
        this.interestRateDisplay = this.element.querySelector('.js-stepper-display');
        this.stepperMinusButton = this.element.querySelector('.js-stepper-minus');
        this.stepperPlusButton = this.element.querySelector('.js-stepper-plus');
        this.loaderElement = this.element.querySelector('.calculator-asset-finance-tab__loader');
        this.errorElement = this.element.querySelector('.calculator-asset-finance-tab__error');
        this.resultsInnerElement = this.element.querySelector('.calculator-asset-finance-tab__results-inner');
        this.setDefaultValues();
        this.setupValidation();
        this.updateStepperDisplay();
        var rangeInput = this.form.querySelector('[name="term"]');
        if (rangeInput) {
            this.updateRangeDisplay(rangeInput);
        }
    };
    CalculatorAssetFinanceTab.prototype.bindEvents = function () {
        var _this = this;
        if (this.clearInputsButton) {
            this.clearInputsButton.addEventListener('click', function (e) {
                e.preventDefault();
                _this.resetForm();
            });
        }
        if (this.calculateButton) {
            this.calculateButton.addEventListener('click', function (e) {
                e.preventDefault();
                clearTimeout(_this.debounceTimer);
                if (_this.validateAllInputs()) {
                    _this.setCalculatingState(true);
                    _this.calculateAccessFinance();
                }
            });
        }
        if (this.stepperPlusButton) {
            this.stepperPlusButton.addEventListener('click', function (e) {
                e.preventDefault();
                _this.handleStepperClick('up');
            });
        }
        if (this.stepperMinusButton) {
            this.stepperMinusButton.addEventListener('click', function (e) {
                e.preventDefault();
                _this.handleStepperClick('down');
            });
        }
        var rangeInput = this.form.querySelector('[name="term"]');
        if (rangeInput) {
            rangeInput.addEventListener('input', function () {
                _this.updateRangeDisplay(rangeInput);
                _this.triggerAutoCalculation();
            });
        }
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                var name = input.getAttribute('name');
                if (name === 'term' || name === 'term_display') {
                    return;
                }
                if (input.getAttribute('type') === 'radio') {
                    input.addEventListener('change', function () {
                        _this.updatePaymentLabel(input.value);
                        _this.triggerAutoCalculation();
                    });
                    return;
                }
                input.addEventListener('input', function () {
                    if (name === 'interest_rate') {
                        _this.updateStepperDisplay();
                    }
                    _this.triggerAutoCalculation();
                });
            });
        }
    };
    CalculatorAssetFinanceTab.prototype.triggerAutoCalculation = function () {
        var _this = this;
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(function () {
            if (_this.validateAllInputs()) {
                _this.calculateAccessFinance();
            }
        }, 500);
    };
    // Toggle the CALCULATE button's "working" state. This calculator fetches
    // results from an API, so the state is cleared when the response resolves.
    CalculatorAssetFinanceTab.prototype.setCalculatingState = function (isCalculating) {
        if (!this.calculateButton) {
            return;
        }
        var button = this.calculateButton;
        if (isCalculating) {
            if (this.calculateButtonText === undefined) {
                this.calculateButtonText = button.textContent || 'CALCULATE';
            }
            button.classList.add('is-calculating');
            button.disabled = true;
            button.textContent = 'Calculating...';
        }
        else {
            button.classList.remove('is-calculating');
            button.disabled = false;
            button.textContent = this.calculateButtonText || 'CALCULATE';
        }
    };
    // Brief highlight on the results so the user sees that the figures refreshed.
    CalculatorAssetFinanceTab.prototype.pulseResults = function () {
        if (this.resultsElement) {
            this.resultsElement.classList.remove('is-updated');
            // Force reflow so the animation can be retriggered on repeated clicks.
            void this.resultsElement.offsetWidth;
            this.resultsElement.classList.add('is-updated');
            this.resultsElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    };
    CalculatorAssetFinanceTab.prototype.handleStepperClick = function (direction) {
        if (!this.interestRateInput)
            return;
        var currentValue = parseFloat(this.interestRateInput.value) || 0;
        var step = 0.25;
        if (direction === 'up') {
            currentValue = Math.min(27.25, currentValue + step);
        }
        else {
            currentValue = Math.max(1, currentValue - step);
        }
        currentValue = Math.round(currentValue * 100) / 100;
        this.interestRateInput.value = currentValue.toString();
        this.updateStepperDisplay();
        this.triggerAutoCalculation();
    };
    CalculatorAssetFinanceTab.prototype.updateStepperDisplay = function () {
        if (!this.interestRateInput || !this.interestRateDisplay)
            return;
        var value = parseFloat(this.interestRateInput.value) || 0;
        this.interestRateDisplay.textContent = value + "%";
        if (this.stepperMinusButton) {
            if (value <= 1) {
                this.stepperMinusButton.classList.add('disabled');
                this.stepperMinusButton.setAttribute('aria-disabled', 'true');
            }
            else {
                this.stepperMinusButton.classList.remove('disabled');
                this.stepperMinusButton.removeAttribute('aria-disabled');
            }
        }
        if (this.stepperPlusButton) {
            if (value >= 27.25) {
                this.stepperPlusButton.classList.add('disabled');
                this.stepperPlusButton.setAttribute('aria-disabled', 'true');
            }
            else {
                this.stepperPlusButton.classList.remove('disabled');
                this.stepperPlusButton.removeAttribute('aria-disabled');
            }
        }
    };
    CalculatorAssetFinanceTab.prototype.updateRangeDisplay = function (rangeInput) {
        var display = this.form.querySelector('[name="term_display"]');
        if (display) {
            display.value = rangeInput.value;
        }
    };
    CalculatorAssetFinanceTab.prototype.updatePaymentLabel = function (frequency) {
        var isMonthly = frequency === 'MONTHLY';
        if (this.bannerTitleElement) {
            this.bannerTitleElement.textContent = isMonthly
                ? 'Your estimated monthly payment:'
                : 'Your estimated annual payment:';
        }
        if (this.repaymentsLabelElement) {
            this.repaymentsLabelElement.textContent = isMonthly ? 'Monthly repayments' : 'Annual repayments';
        }
    };
    CalculatorAssetFinanceTab.prototype.getPaymentFrequency = function () {
        var checked = this.form.querySelector('input[name="payment_frequency"]:checked');
        return checked ? checked.value : 'MONTHLY';
    };
    CalculatorAssetFinanceTab.prototype.calculateAccessFinance = function () {
        var _this = this;
        this.showLoader();
        this.hideError();
        var paymentFrequency = this.getPaymentFrequency();
        var postData = {
            amountToFinance: Number(this.getInputValue('finance_amount')),
            interestRate: Number(this.getInputValue('interest_rate')),
            balloonPercent: Number(this.getInputValue('balloon_percentage') || '0'),
            term: Number(this.getInputValue('term')),
            averageDailyBalance: Number(this.getInputValue('average_daily_balance')),
            paymentFrequency: paymentFrequency === 'MONTHLY' ? 1 : 12
        };
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var url = (this.baseUrl || window.location.origin) + '/leadsutils/vafafcalc';
        this.formsService.postForm(url, postData, config).then(function (response) {
            if (response && response.status === 200 && response.data && response.data.message
                && String(response.data.message).includes('OK')) {
                _this.displayCalculations(response.data);
                _this.pulseResults();
            }
            else {
                _this.showError();
            }
            _this.hideLoader();
            _this.setCalculatingState(false);
        }).catch(function () {
            _this.showError();
            _this.hideLoader();
            _this.setCalculatingState(false);
        });
    };
    CalculatorAssetFinanceTab.prototype.displayCalculations = function (data) {
        var _this = this;
        var formatter = function (value) { return _this.financeCalculatorService.formatter(value); };
        // Banner shows the new approximate average repayment for the selected frequency
        if (this.monthlyRepaymentElement) {
            this.monthlyRepaymentElement.textContent = 'R ' + formatter(data.averageReducedInstalment);
        }
        if (this.repaymentsElement) {
            this.repaymentsElement.textContent = formatter(data.instalmentAmount);
        }
        if (this.totalRepaymentsElement) {
            this.totalRepaymentsElement.textContent = formatter(data.totalInstalments);
        }
        if (this.financeChargesElement) {
            this.financeChargesElement.textContent = formatter(data.totalInterest);
        }
        if (this.avgSavingElement) {
            this.avgSavingElement.textContent = formatter(data.averageInstalmentReduction);
        }
        if (this.newInterestRateElement) {
            this.newInterestRateElement.textContent = data.effectiveDiscountedRate;
        }
        if (this.newTotalRepaymentsElement) {
            this.newTotalRepaymentsElement.textContent = formatter(data.totalReducedInstalments);
        }
        if (this.interestReductionElement) {
            this.interestReductionElement.textContent = formatter(data.totalCreditInterest);
        }
        this.showResults();
    };
    CalculatorAssetFinanceTab.prototype.showLoader = function () {
        if (this.loaderElement) {
            this.loaderElement.classList.remove('hidden');
        }
    };
    CalculatorAssetFinanceTab.prototype.hideLoader = function () {
        if (this.loaderElement) {
            this.loaderElement.classList.add('hidden');
        }
    };
    CalculatorAssetFinanceTab.prototype.showError = function () {
        if (this.errorElement) {
            this.errorElement.classList.remove('hidden');
        }
        if (this.resultsInnerElement) {
            this.resultsInnerElement.classList.add('hidden');
        }
    };
    CalculatorAssetFinanceTab.prototype.hideError = function () {
        if (this.errorElement) {
            this.errorElement.classList.add('hidden');
        }
    };
    CalculatorAssetFinanceTab.prototype.showResults = function () {
        if (this.resultsInnerElement) {
            this.resultsInnerElement.classList.remove('hidden');
        }
    };
    CalculatorAssetFinanceTab.prototype.getInputValue = function (name) {
        if (this.form) {
            var input = this.form.querySelector("[name=\"" + name + "\"]");
            if (name === 'balloon_percentage' && input && input.value === '') {
                return '0';
            }
            return input ? input.value || '0' : '0';
        }
        return '0';
    };
    CalculatorAssetFinanceTab.prototype.setupValidation = function () {
        var _this = this;
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                if (input.getAttribute('type') !== 'radio') {
                    input.addEventListener('input', function () { return _this.validateInput(input); });
                }
            });
        }
    };
    CalculatorAssetFinanceTab.prototype.validateInput = function (input) {
        var name = input.getAttribute('name');
        if (name === 'term_display' || input.getAttribute('type') === 'radio') {
            return true;
        }
        var value = parseFloat(input.value);
        var fieldContainer = input.closest('.calculator-asset-finance-tab__field');
        var validationMessage = fieldContainer ? fieldContainer.querySelector('.validation-message') : null;
        var showError = function (message) {
            if (validationMessage) {
                validationMessage.textContent = message;
                validationMessage.style.display = 'block';
                input.classList.add('is-invalid');
            }
            return false;
        };
        var clearError = function () {
            if (validationMessage) {
                validationMessage.style.display = 'none';
                input.classList.remove('is-invalid');
            }
            return true;
        };
        switch (name) {
            case 'finance_amount':
                if (input.value.trim() === '' || isNaN(value)) {
                    return showError('Finance amount is required');
                }
                if (value < 100000 || value > 100000000) {
                    return showError('Enter an amount between 100 000 and 100 000 000');
                }
                break;
            case 'balloon_percentage':
                if (input.value.trim() === '') {
                    return clearError();
                }
                if (isNaN(value) || value < 0 || value > 35) {
                    return showError('Enter a balloon percentage between 0 and 35');
                }
                break;
            case 'average_daily_balance':
                if (input.value.trim() === '' || isNaN(value)) {
                    return showError('Average daily balance is required');
                }
                if (value < 5000 || value > 100000000) {
                    return showError('Enter an amount between 5 000 and 100 000 000');
                }
                break;
            case 'interest_rate':
                if (input.value.trim() === '' || isNaN(value)) {
                    return showError('Interest rate is required');
                }
                if (value < 1 || value > 27.25) {
                    return showError('Enter an interest rate between 1 and 27.25');
                }
                break;
            case 'term':
                if (isNaN(value) || value < 12 || value > 72) {
                    return showError('Value must be between 12 and 72 months');
                }
                break;
        }
        return clearError();
    };
    CalculatorAssetFinanceTab.prototype.validateAllInputs = function () {
        var _this = this;
        var isValid = true;
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                if (input.getAttribute('name') !== 'term_display' && input.getAttribute('type') !== 'radio') {
                    if (!_this.validateInput(input)) {
                        isValid = false;
                    }
                }
            });
        }
        return isValid;
    };
    CalculatorAssetFinanceTab.prototype.setDefaultValues = function () {
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                if (input.getAttribute('type') === 'radio') {
                    return;
                }
                var defaultValue = input.getAttribute('data-value');
                if (defaultValue !== null) {
                    input.value = defaultValue;
                }
            });
        }
    };
    CalculatorAssetFinanceTab.prototype.resetForm = function () {
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                if (input.getAttribute('type') === 'radio') {
                    input.checked = input.value === 'MONTHLY';
                }
                else {
                    var defaultValue = input.getAttribute('data-value');
                    if (defaultValue !== null) {
                        input.value = defaultValue;
                    }
                }
                input.classList.remove('is-invalid');
            });
            var validationMessages = this.form.querySelectorAll('.validation-message');
            validationMessages.forEach(function (message) {
                message.style.display = 'none';
                message.textContent = '';
            });
        }
        this.hideError();
        this.hideLoader();
        this.showResults();
        var resultElements = [
            this.repaymentsElement,
            this.totalRepaymentsElement,
            this.financeChargesElement,
            this.avgSavingElement,
            this.newTotalRepaymentsElement,
            this.interestReductionElement
        ];
        resultElements.forEach(function (el) {
            if (el) {
                el.textContent = '0.00';
            }
        });
        if (this.newInterestRateElement) {
            this.newInterestRateElement.textContent = '0';
        }
        if (this.monthlyRepaymentElement) {
            this.monthlyRepaymentElement.textContent = 'R 0.00';
        }
        this.updatePaymentLabel('MONTHLY');
        this.updateStepperDisplay();
        var rangeInput = this.form.querySelector('[name="term"]');
        if (rangeInput) {
            this.updateRangeDisplay(rangeInput);
        }
    };
    return CalculatorAssetFinanceTab;
}(Base));
export { CalculatorAssetFinanceTab };



//////////////////
// WEBPACK FOOTER
// ./components/calculator-asset-finance-tab/calculator-asset-finance-tab.component.ts
// module id = 1135
// module chunks = 0